import notificationTypes from '../../constants/notificationTypes';

export function isQANewAnswerNotification(notification) {
    return !!notification.content?.data?.type == notificationTypes.NEW_ANSWER;
}
